export class ModalNotificacion {
    departamento: string;
    provincia: string;
    distrito: string;
    direccion: string;
    correoPN: string;
    nroDocPN: string;
    dscTipoDocPN: string;
}

